import cn from 'classnames'

import { InfoBlock, InfoBlockType } from 'cng-common/components/infoBlock'
import { Translation } from 'cng-common/features/translations'

import { TRANSLATION_KEYS } from '../../translations'

import styles from './SobCompetitorsWarning.module.scss'

interface ISobCompetitorsWarning {
  className?: string
}
export const SobCompetitorsWarning = ({ className }: ISobCompetitorsWarning) => {
  return (
    <div className={cn(styles.root, className)}>
      <InfoBlock
        type={InfoBlockType.Warning}
        text={
          <div>
            <div className={styles.row}>
              <span className={cn(styles.highlighted, styles.bold)}>
                <Translation span text={TRANSLATION_KEYS.warning.important} /> &nbsp;
              </span>
              <span>
                <Translation span text={TRANSLATION_KEYS.warning.importantComment} />
              </span>
            </div>
            <div className={styles.row}>
              <Translation span text={TRANSLATION_KEYS.warning.secondText} /> &nbsp;
              <span className={styles.bold}>
                <Translation span text={TRANSLATION_KEYS.warning.secondTextHighlighted} />
              </span>
            </div>
            <div>
              <Translation span text={TRANSLATION_KEYS.warning.thirdText} /> &nbsp;
              <span className={styles.highlighted}>
                <Translation span text={TRANSLATION_KEYS.warning.thirdTextHighlighted} />
                &nbsp;
              </span>
              <Translation span text={TRANSLATION_KEYS.warning.fourText} />
            </div>
            <div>
              <span className={styles.highlighted}>
                <Translation span text={TRANSLATION_KEYS.warning.fourTextHighlighted} />
                &nbsp;
              </span>
              <Translation span text={TRANSLATION_KEYS.warning.fiveText} />
            </div>
            <div>
              <Translation span text={TRANSLATION_KEYS.warning.sixText} />
            </div>
          </div>
        }
      />
    </div>
  )
}
